import Particles from "react-tsparticles";
import { loadSlim } from "tsparticles-slim";
import React, { useCallback, useMemo } from "react";



const ParticlesBackground = () => {
  const options = useMemo(() => {
    return {
      
      particles: {
        number: {
          value: 50, // cantidad inicial de particulas
          density: {
            enable: true,
            value_area: 600
          }
        },
        color: {
          value: "#ffffff"  // Color de cada punto en la coneccion
        },
        shape: {
          type: "circle",
          stroke: {
            width: 2, // ancho de borde de cada punto
            color: "rgba(137, 43, 226, 0.5)" // color de borde de cada punto
          },
          polygon: {
            nb_sides: 6
          }
        },
        opacity: {
          value: 0.3,
          random: true,
          anim: {
            enable: true,
            speed: 0.5,
            opacity_min: 0.1,
            sync: true
          }
        },
        size: {   // tamaño de cada punto
          value: 3.5, 
          random: true,
          anim: {
            enable: false,
            speed: 40,
            size_min: 0.1,
            sync: false
          }
        },
        line_linked: {  //lineas de union entre los puntos
          enable: true,
          distance: 150,
          color: "#ffffff",
          opacity: 0.2,
          width: 0.5
        },
        move: {   // movimiento de los puntos
          enable: true,
          speed: 3,
          direction: "none",
          random: true,
          straight: false,
          out_mode: "out",
          bounce: false,
          attract: {
            enable: true,
            rotateX: 600,
            rotateY: 1200
          }
        }
      },
      interactivity: {
        detect_on: "canvas",
        events: {
          onhover: {
            enable: true,
            mode: "grab"
          },
          onclick: {
            enable: true,
            mode: "push"
          },
          resize: true
        },
        modes: {
          grab: {
            distance: 140,
            line_linked: {
              opacity: 1
            }
          },
          bubble: {
            distance: 400,
            size: 40,
            duration: 2,
            opacity: 8,
            speed: 3
          },
          repulse: {
            distance: 200,
            duration: 0.4
          },
          push: {
            particles_nb: 5
          },
          remove: {
            particles_nb: 10
          }
        }
      },
      fpsLimit: 120,
      retina_detect: true,
      pauseOnBlur: true,
      pauseOnOutsideViewport: true,
    };
  }, []);
  const particlesInit = useCallback((engine) => {
    loadSlim(engine);
  }, []);

  return (
    <Particles
      id='tsparticles'
      init={particlesInit}
      options={options}
    />
  );

};


export default ParticlesBackground;